import { useEffect } from 'react'
import { getAllWhitelist } from 'services/admin'
import { useDispatch, useSelector } from 'react-redux'
import { selectWhitelist } from 'store/whitelist/selectors'
import {
  setCurrentPage,
  setData,
  setLoading,
  setTotalItem,
  setTotalPage,
} from 'store/whitelist/whitelistSlice'
import WhitelistHeader from './header'
import WhitelistData from './data'
import 'styles/pages/_whitelist-artis.scss'
import WhitelistPagination from './pagination'

const WhitelistPage = () => {
  const { currentPage, pageSize, status } = useSelector(selectWhitelist)
  const dispatch = useDispatch()

  async function getData(page: number, showLoading = true) {
    try {
      if (showLoading) dispatch(setLoading(true))
      const res = await getAllWhitelist({
        limit: pageSize,
        page,
        status,
      }).catch(() => {})
      if (!res || !res.data || !(res.status >= 200 && res.status <= 299)) return

      dispatch(setCurrentPage(res.data.currentPage))
      dispatch(setTotalPage(res.data.totalPage))
      dispatch(setTotalItem(res.data.total))
      dispatch(setData(res.data.data))
    } catch (error: any) {
      console.log(error)
    } finally {
      dispatch(setLoading(false))
    }
  }

  useEffect(() => {
    getData(1)
  }, [status])

  return (
    <div className='wa__container'>
      <div className='wa__panel'>
        <WhitelistHeader
          onContractHasBeenSent={() => getData(currentPage, false)}
        />

        <WhitelistData updateData={() => getData(currentPage, false)} />

        <WhitelistPagination
          onChange={(i) => {
            if (i !== currentPage) getData(i)
          }}
        />
      </div>
    </div>
  )
}

export default WhitelistPage
